import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/governanca-e-gestao',
		component: Base,
		children: [
			{
				path: '',
				name: 'GestaoEGovernancaList',
				component: List,
				meta: {
					path: '/site/governanca-e-gestao',
					pai: 'Site',
					title: 'Admin - Gestão e Governança',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Gestão e Governança',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'GestaoEGovernancaNovo',
				component: Form,
				meta: {
					path: '/site/governanca-e-gestao',
					pai: 'Site',
					title: 'Admin - Gestão e Governança - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Gestão e Governança',
						class: '',
						active: false,
						url: '/site/governanca-e-gestao'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'GestaoEGovernancaEditar',
				component: Form,
				meta: {
					path: '/site/governanca-e-gestao',
					pai: 'Site',
					title: 'Admin - Gestão e Governança - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Gestão e Governança',
						class: '',
						active: false,
						url: '/site/governanca-e-gestao'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]